module.exports = __webpack_public_path__ + "img/closeClean.5b20effd.svg";